import { useMemo } from 'react';
import { getPageIdToPathFrom } from '@typedream/data';
import { useSpaceAndPageIDFromRouter } from '../data/space/hooks';
import { useGetSpaceQuery } from '../store';
import getTypedreamSubdomain from './getTypedreamSubdomain';

const useCurrentPagePath = () => {
  const [spaceID, pageID] = useSpaceAndPageIDFromRouter();
  const { data: space } = useGetSpaceQuery([spaceID], { skip: !spaceID });

  const ret = useMemo(() => {
    if (!space)
      return {
        typedreamSubdomain: '',
        customDomain: null,
        currentPathWithSlug: null,
        currentPathWithoutSlug: null,
      };
    const { slug } = space;
    const pageIdMap = getPageIdToPathFrom(slug, space.routes);
    const pathWithSlug = pageIdMap[pageID];
    const typedreamSubdomain = getTypedreamSubdomain(space);
    const customDomain =
      space?.custom_domain && space?.custom_domain !== '' ? space?.custom_domain : null;
    if (!pathWithSlug) {
      return {
        typedreamSubdomain,
        customDomain,
        currentPathWithSlug: null,
        currentPathWithoutSlug: null,
      };
    }

    const paths = pathWithSlug.split('/');
    paths.shift();

    const currentPathWithoutSlug = paths.join('/');
    const currentPathWithSlug = pathWithSlug;

    return {
      typedreamSubdomain,
      customDomain,
      currentPathWithSlug,
      currentPathWithoutSlug,
    };
  }, [space, pageID]);

  return ret;
};

export default useCurrentPagePath;
